export var SqlQueryExecutionSortField;
(function (SqlQueryExecutionSortField) {
    SqlQueryExecutionSortField["SQL_QUERY_EXECUTION_SORT_FIELD_CREATED_AT"] = "createdAt";
    SqlQueryExecutionSortField["SQL_QUERY_EXECUTION_SORT_FIELD_FINISHED_AT"] = "finishedAt";
})(SqlQueryExecutionSortField || (SqlQueryExecutionSortField = {}));
